import React from 'react'

export const RateSymbol = ({
  className,
  size,
}: {
  className?: string
  size: number
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 11 11'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M1.05933 1.0625L1.05933 8.41565C1.05933 9.13367 1.63893 9.71327 2.35694 9.71327L9.71009 9.71327'
        stroke='currentColor'
        stroke-width='0.854527'
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M2.35718 7.54804L4.34253 5.22964C4.67126 4.84901 5.25518 4.82305 5.60987 5.18205L6.02078 5.59297C6.37546 5.94765 6.95939 5.92602 7.28811 5.54539L9.27779 3.22266'
        stroke='currentColor'
        stroke-width='0.854527'
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  )
}
